import { useState } from "react";

function Skills() {

const [openIndex, setOpenIndex] = useState(null);

const toggleSkill = (index) => {
setOpenIndex(openIndex === index ? null : index);
};

const skillsData = [


{
title: "🧑‍💻 Programming Languages",
items: [
"🐍 Python",
"☕ Java",
"🎮 C#"
]
},

{
title: "💻 Full Stack Development",
items: [
"🌐 HTML",
"🎨 CSS",
"⚡ JavaScript",
"⚛ React",
"🟢 Node.js",
"🐘 PostgreSQL",
"🛢 MySQL",
"🔗 Web3",
"🧠 DApps"
]
},



{
title: "🤖 AI & Machine Learning",
items: [
"🧠 Machine Learning",
"🧬 Deep Learning",
"📊 Data Analysis",
"📈 NumPy",
"🐼 Pandas",
"🔥 PyTorch",
"🧪 TensorFlow"
]
},

{
title: "🎨 Creative Skills",
items: [
"🧊 3D Modelling",
"✏ Illustration",
"📝 Sketching",
"🖼 Digital Image Creation",
"🎬 Digital Video Creation"
]
},

{
title: "📐 Design & UX",
items: [
"🎯 UI / UX Design",
"🎨 Figma",
"📱 Mockup",
"📊 Prototyping",
"🧩 Product Design"
]
},

{
title: "🛠 Tools & Platforms",
items: [
"🐙 GitHub",
"⚙ Git",
"💻 VS Code",
"📱 Android Studio",
"🎮 Unity",
"🧊 Blender",
"🌍 Sketchfab",
"🚀 Vercel",
"🌐 Netlify",
"🔗 n8n",
"🎨 Leonardo AI",
"🧊 Hitem3D",
"+more"
]
},

{
title: "📢 Media & Content",
items: [
"🎬 Video Editing",
"📷 Content Creation",
"📈 Digital Marketing",
"📖 Storytelling",
"🏷 Branding"
]
},

{
title: "🧠 Product & Strategy",
items: [
"📦 Product Management",
"💡 Creative Problem Solving",
"🎯 Prompt Engineering"
]
},

{
title: "🤝 Soft Skills",
items: [
"🗣 Communication",
"🔄 Adaptability",
"📚 Continuous Learning",
"🎨 Creativity"
]
}

];

return (

<section id="skills" className="reveal">

<div className="section-title">
<h2>Skills</h2>
</div>

<div className="skills-accordion">

{skillsData.map((skill, index) => (

<div className="skill-category" key={index}>

<button
className="skill-header"
onClick={() => toggleSkill(index)}
>

{skill.title}

<span className="arrow">
{openIndex === index ? "▲" : "▼"}
</span>

</button>

{openIndex === index && (

<div className="skill-content">

{skill.items.map((item, i) => (

<span key={i} className={item === "+more" ? "more-skill" : ""}>
{item}
</span>

))}

</div>

)}

</div>

))}

</div>

</section>

);

}

export default Skills;